/**
 * Hardcoded UUID returned as user ID when the asset creator is the Vestigas system user.
 */
export const ASSET_CREATOR_USER_ID = '8814cf34-fd7a-4a3a-8abd-eea291dfea35';
